// components/MediaModal.jsx (Perbaikan)
import { useEffect } from "react";

const MediaModal = ({ karya, onClose }) => {
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') onClose();
    };
    
    document.addEventListener('keydown', handleEscape);
    document.body.style.overflow = 'hidden';
    
    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'unset';
    };
  }, [onClose]);

  if (!karya) return null;
  
  const isVideo = karya.mediaType === 'video';
  const authorText = Array.isArray(karya.author) ? karya.author.join(', ') : karya.author;

  return (
    <div 
      className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4 backdrop-blur-sm"
      onClick={onClose}
    >
      <div 
        className="bg-white dark:bg-gray-900 rounded-2xl max-w-6xl w-full max-h-[95vh] flex flex-col shadow-2xl border border-gray-200 dark:border-gray-700"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="flex justify-between items-center p-6 border-b border-gray-200 dark:border-gray-700 flex-shrink-0">
          <div className="flex-1">
            <h2 className="text-2xl font-bold text-gray-900 dark:text-white line-clamp-1">
              {karya.title}
            </h2>
            <p className="text-lg text-gray-600 dark:text-gray-400 mt-1">
              by {authorText}
            </p>
          </div>
          <button 
            onClick={onClose}
            className="ml-4 text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200 transition-colors duration-200 p-2 hover:bg-gray-100 dark:hover:bg-gray-800 rounded-lg"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        {/* Media Content */}
        <div className="flex-grow flex items-center justify-center bg-black rounded-b-2xl overflow-hidden p-4">
          {isVideo ? (
            <video 
              src={karya.mediaUrl} 
              controls 
              autoPlay 
              className="max-w-full max-h-[70vh] rounded-lg"
              controlsList="nodownload"
            />
          ) : (
            <img 
              src={karya.mediaUrl} 
              alt={karya.title} 
              className="max-w-full max-h-[70vh] object-contain rounded-lg"
            />
          )}
        </div>

        {/* Footer Info */}
        <div className="p-6 border-t border-gray-200 dark:border-gray-700 flex-shrink-0">
          <div className="flex items-center justify-between text-sm text-gray-600 dark:text-gray-400">
            <div className="flex items-center gap-4">
              <span className="flex items-center gap-1">
                <svg className="w-4 h-4 text-purple-500" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"/>
                </svg>
                {karya.voteCount || 0} Votes
              </span>
              <span className="px-2 py-1 bg-gray-100 dark:bg-gray-800 rounded-md text-xs">
                {isVideo ? 'Video' : 'Gambar'}
              </span>
            </div>
            {karya.createdAt && (
              <span>
                Diupload pada {karya.createdAt.toDate().toLocaleDateString('id-ID')}
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MediaModal;